import React from 'react';
import { planConfigs } from '../../config/planConfigs';
import { LIMIARES } from '../../utils/seoMetrics';
import { useIdioma } from '../../i18n';
import '../../styles/Perguntas.css';

const creditos = (plano) => planConfigs[plano].features.monthly_credits;

/* Os números das respostas vêm do mesmo lugar que o produto usa. */
const VALORES = {
  r4: { lenta: LIMIARES.CARGA_LENTA_MS / 1000, critica: LIMIARES.CARGA_CRITICA_MS / 1000 },
  r5: { basic: creditos('Basic'), guru: creditos('Guru'), pro: creditos('Pro') }
};
const ITENS = 10;

/** Perguntas e respostas como texto corrido: tudo à vista, sem sanfona. */
const Perguntas = () => {
  const { t } = useIdioma();

  return (
    <section className="perguntas" id="perguntas" aria-labelledby="perguntas-titulo">
      <div className="nh-grade">
        <h2 id="perguntas-titulo" data-r>{t('inicio.perguntas.titulo')}</h2>
        <div className="perguntas-texto" data-r style={{ '--i': 1 }}>
          {Array.from({ length: ITENS }, (_, i) => i + 1).map((n) => (
            <p key={n}>
              <b>{t(`inicio.perguntas.p${n}`)}</b> {t(`inicio.perguntas.r${n}`, VALORES[`r${n}`])}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Perguntas;
